type IArquivos = {
    arquivo: any;
    nome: string;
};

type ISubPasta = {
    titleSubPasta: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};

type IMaterial = {
    isPaste?: boolean;
    titlePaste?: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
    categoriasPermitidas?: number[];
    permitirEmail?: boolean;
};
type TItem = {
    title: string;
    materiais: IMaterial[];
    categoriasPermitidas?: number[];
    permitirEmail?: boolean;
};

export const ListMateriaisDialogosSocioemocionais: TItem[] = [
    {
        title: 'Professor Diálogos Integrados',
        categoriasPermitidas: [1, 7, 15, 18, 19, 20, 35],
        permitirEmail: true,
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'O que é o Diálogos Socioemocionais',
                        arquivo: 'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/1.+O+que+%C3%A9+o+Di%C3%A1logos+Socioemocionais.pdf',
                    },
                    {
                        nome: 'Caderno do professor',
                        arquivo: 'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/2.+Caderno+do+professor.pdf',
                    },
                    {
                        nome: 'Sistemática de Acompanhamento',
                        arquivo: 'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/3.+Sistem%C3%A1tica+de+Acompanhamento.pdf',
                    },
                    {
                        nome: 'Manual de aplicação da Autoavaliação',
                        arquivo: 'DSE_Materiais_2026/1. Professor Diálogos Integrados/4. Manual de aplicação da Autoavaliação.pdf',
                    },
                ],
                subPastas: [
                    {
                        titleSubPasta: 'Banco de Atividades Inspiracionais',
                        arquivos: [
                            {
                                nome: 'Biologia',
                                arquivo:
                                    'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/4.+Banco+de+Atividades+Inspiracionais/Biologia.pdf',
                            },
                            {
                                nome: 'Ciencias',
                                arquivo:
                                    'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/4.+Banco+de+Atividades+Inspiracionais/Ciencias.pdf',
                            },
                            {
                                nome: 'Fisica',
                                arquivo:
                                    'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/4.+Banco+de+Atividades+Inspiracionais/Fisica.pdf',
                            },
                            {
                                nome: 'Geografia',
                                arquivo:
                                    'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/4.+Banco+de+Atividades+Inspiracionais/Geografia.pdf',
                            },
                            {
                                nome: 'Historia',
                                arquivo:
                                    'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/4.+Banco+de+Atividades+Inspiracionais/Historia.pdf',
                            },
                            {
                                nome: 'Literatura',
                                arquivo:
                                    'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/4.+Banco+de+Atividades+Inspiracionais/Literatura.pdf',
                            },
                            {
                                nome: 'Língua Portuguesa',
                                arquivo:
                                    'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/4.+Banco+de+Atividades+Inspiracionais/L%C3%ADngua+Portuguesa.pdf',
                            },
                            {
                                nome: 'Matematica',
                                arquivo:
                                    'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/4.+Banco+de+Atividades+Inspiracionais/Matematica.pdf',
                            },
                            {
                                nome: 'Quimica',
                                arquivo:
                                    'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/4.+Banco+de+Atividades+Inspiracionais/Quimica.pdf',
                            },
                            {
                                nome: 'Educação Física',
                                arquivo:
                                    'DSE_Materiais_2026/1. Professor Diálogos Integrados/4. Banco de Atividades Inspiracionais/Educacao_Fisica_vf.pdf',
                            },
                            {
                                nome: 'Ensino Religioso',
                                arquivo:
                                    'DSE_Materiais_2026/1. Professor Diálogos Integrados/4. Banco de Atividades Inspiracionais/EnsinoReligioso VF.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Atividade Pré-Autoavaliação',
                        arquivos: [
                            {
                                nome: 'Atividade',
                                arquivo: 'DSE_Materiais_2026/1. Professor Diálogos Integrados/5. Atividade_Pre_Autoavaliacao/1. Atividade.pdf',
                            },
                            {
                                nome: 'Anexo 1 - Monte Matriz',
                                arquivo:
                                    'DSE_Materiais_2026/1. Professor Diálogos Integrados/5. Atividade_Pre_Autoavaliacao/2. Anexo1_Monte_Matriz.pdf',
                            },
                            {
                                nome: 'Anexo 2 - Situações',
                                arquivo:
                                    'DSE_Materiais_2026/1. Professor Diálogos Integrados/5. Atividade_Pre_Autoavaliacao/3. Anexo2_Situacoes.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Material Complementar',
                        arquivos: [
                            {
                                nome: 'Audiobook - Diálogos Socioemocionais',
                                arquivo: 'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/6.+Material+complementar/Audiobook_DSE.mp3',
                            },
                            {
                                nome: 'Infográficos das Macrocompetências',
                                arquivo:
                                    'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/6.+Material+complementar/Infogr%C3%A1ficos+das+Macrocompet%C3%AAncias.pdf',
                            },
                            {
                                nome: 'Priorização de Competências Socioemocionais',
                                arquivo:
                                    'DSE_Materiais_2026/1.+Professor+Di%C3%A1logos+Integrados/6.+Material+complementar/Prioriza%C3%A7%C3%A3o+de+Compet%C3%AAncias+Socioemocionais.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Autoavaliações',
                        subPastas: [
                            {
                                titleSubPasta: 'Caderno - 1ª série',
                                arquivos: [
                                    {
                                        nome: 'A4 - Curiosidade para Aprender - 15',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 1ª série/A4 - CURIOSAIDADE PARA APRENDER - 15.pdf',
                                    },
                                    {
                                        nome: 'A4 - Imaginação Criativa - 11',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 1ª série/A4 - IMAGINAÇÃO CRIATIVA - 11.pdf',
                                    },
                                    {
                                        nome: 'A4 - Iniciativa Social - 6',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 1ª série/A4 - INICIATIVA SOCIAL - 6.pdf',
                                    },
                                    {
                                        nome: 'A4 - Persistência - 17',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 1ª série/A4 - PERSISTÊNCIA - 17.pdf',
                                    },
                                    {
                                        nome: 'A4 - Respeito - 4',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 1ª série/A4 - RESPEITO - 4.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância à Frustração - 10',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 1ª série/A4 - TOLERÂNCIA À FRUSTRAÇÃO - 10.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 1ª série/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 1ª série/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 2ª série',
                                arquivos: [
                                    {
                                        nome: 'A4 - Assertividade - 18',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 2ª série/A4 - ASSERTIVIDADE - 18.pdf',
                                    },
                                    {
                                        nome: 'A4 - Autoconfiança - 6',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 2ª série/A4 - AUTOCONFIANÇA - 6.pdf',
                                    },
                                    {
                                        nome: 'A4 - Empatia - 13',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 2ª série/A4 - EMPATIA - 13.pdf',
                                    },
                                    {
                                        nome: 'A4 - Foco - 3',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 2ª série/A4 - FOCO - 3.pdf',
                                    },
                                    {
                                        nome: 'A4 - Interesse Artístico - 7',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 2ª série/A4 - INTERESSE ARTÍSTICO - 7.pdf',
                                    },
                                    {
                                        nome: 'A4 - Organização - 13',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 2ª série/A4 - ORGANIZAÇÃO - 13.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 2ª série/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 2ª série/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 3ª série',
                                arquivos: [
                                    {
                                        nome: 'A4 - Confiança - 16',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 3ª série/A4 - CONFIANÇA - 16.pdf',
                                    },
                                    {
                                        nome: 'A4 - Curiosidade para Aprender - 16',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 3ª série/A4 - CURIOSAIDADE PARA APRENDER - 16.pdf',
                                    },
                                    {
                                        nome: 'A4 - Determinação - 19',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 3ª série/A4 - DETERMINAÇÃO - 19.pdf',
                                    },
                                    {
                                        nome: 'A4 - Entusiasmo - 9',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 3ª série/A4 - ENTUSIASMO - 9.pdf',
                                    },
                                    {
                                        nome: 'A4 - Responsabilidade - 8',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 3ª série/A4 - RESPONSABILIDADE - 8.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância ao Estresse - 15',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 3ª série/A4 - TOLERÂNCIA AO ESTRESSE - 15.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 3ª série/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 3ª série/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 6º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Determinação - 18',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 6° ano/A4 - DETERMINAÇÃO - 18.pdf',
                                    },
                                    {
                                        nome: 'A4 - Empatia - 11',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 6° ano/A4 - EMPATIA - 11.pdf',
                                    },
                                    {
                                        nome: 'A4 - Imaginação Criativa - 10',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 6° ano/A4 - IMAGINAÇÃO CRIATIVA - 10.pdf',
                                    },
                                    {
                                        nome: 'A4 - Iniciativa Social - 4',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 6° ano/A4 - INICIATIVA SOCIAL - 4.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância à Frustração - 9',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 6° ano/A4 - TOLERÂNCIA À FRUSTRAÇÃO - 9.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 6° ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 6° ano/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 7º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Assertividade - 17',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 7° ano/A4 - ASSERTIVIDADE - 17.pdf',
                                    },
                                    {
                                        nome: 'A4 - Curiosidade para Aprender - 14',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 7° ano/A4 - CURIOSAIDADE PARA APRENDER - 14.pdf',
                                    },
                                    {
                                        nome: 'A4 - Foco - 2',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 7° ano/A4 - FOCO - 2.pdf',
                                    },
                                    {
                                        nome: 'A4 - Respeito - 3',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 7° ano/A4 - RESPEITO - 3.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância ao Estresse - 13',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 7° ano/A4 - TOLERÂNCIA AO ESTRESSE - 13.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 7° ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 7° ano/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 8º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Autoconfiança - 5',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 8°ano/A4 - AUTOCONFIANÇA - 5.pdf',
                                    },
                                    {
                                        nome: 'A4 - Empatia - 12',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 8°ano/A4 - EMPATIA - 12.pdf',
                                    },
                                    {
                                        nome: 'A4 - Interesse Artístico - 6',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 8°ano/A4 - INTERESSE ARTÍSTICO - 6.pdf',
                                    },
                                    {
                                        nome: 'A4 - Organização - 12',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 8°ano/A4 - ORGANIZAÇÃO - 12.pdf',
                                    },
                                    {
                                        nome: 'A4 - Responsabilidade - 7',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 8°ano/A4 - RESPONSABILIDADE - 7.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 8°ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 8°ano/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 9º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Confiança - 15',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 9° ano/A4 - CONFIANÇA - 15.pdf',
                                    },
                                    {
                                        nome: 'A4 - Entusiasmo - 8',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 9° ano/A4 - ENTUSIASMO - 8.pdf',
                                    },
                                    {
                                        nome: 'A4 - Iniciativa Social - 5',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 9° ano/A4 - INICIATIVA SOCIAL - 5.pdf',
                                    },
                                    {
                                        nome: 'A4 - Persistência - 16',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 9° ano/A4 - PERSISTÊNCIA - 16.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância ao Estresse - 14',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 9° ano/A4 - TOLERÂNCIA AO ESTRESSE - 14.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 9° ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/1. Professor Diálogos Integrados/7. Autoavaliações/Caderno - 9° ano/Página final.pdf',
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        title: 'Professor Projeto de Vida',
        categoriasPermitidas: [2, 13, 26, 35],
        permitirEmail: true,
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'O que é o Diálogos Socioemocionais',
                        arquivo: 'DSE_Materiais_2026/2.+Professor+Projeto+de+Vida/1.+O+que+%C3%A9+o+Di%C3%A1logos+Socioemocionais.pdf',
                    },
                    {
                        nome: 'Caderno do professor',
                        arquivo: 'DSE_Materiais_2026/2.+Professor+Projeto+de+Vida/2.+Caderno+do+professor.pdf',
                    },
                    {
                        nome: 'Sistemática de Acompanhamento',
                        arquivo: 'DSE_Materiais_2026/2.+Professor+Projeto+de+Vida/3.+Sistem%C3%A1tica+de+Acompanhamento.pdf',
                    },
                    {
                        nome: 'Manual de aplicação da Autoavaliação',
                        arquivo:
                            'DSE_Materiais_2026/2.+Professor+Projeto+de+Vida/4.+Manual+de+aplica%C3%A7%C3%A3o+da+Autoavalia%C3%A7%C3%A3o.pdf',
                    },
                ],
                subPastas: [
                    {
                        titleSubPasta: 'Atividades Inspiracionais',
                        arquivos: [
                            {
                                nome: 'Projeto de Vida - Ensino Médio',
                                arquivo:
                                    'DSE_Materiais_2026/2.+Professor+Projeto+de+Vida/4.+Atividades_Inspiracionais/Projeto_de_vida_EnsinoM%C3%A9dio.pdf',
                            },
                            {
                                nome: 'Projeto de Vida - Fundamental Anos Finais',
                                arquivo:
                                    'DSE_Materiais_2026/2.+Professor+Projeto+de+Vida/4.+Atividades_Inspiracionais/ProjetodeVida_Fund_AnosFinais.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Atividade Pré-Autoavaliação',
                        arquivos: [
                            {
                                nome: 'Atividade',
                                arquivo: 'DSE_Materiais_2026/2. Professor Projeto de Vida/5. Atividade_Pre_Autoavaliacao/1. Atividade.pdf',
                            },
                            {
                                nome: 'Anexo 1 - Monte Matriz',
                                arquivo:
                                    'DSE_Materiais_2026/2. Professor Projeto de Vida/5. Atividade_Pre_Autoavaliacao/2. Anexo1_Monte_Matriz.pdf',
                            },
                            {
                                nome: 'Anexo 2 - Situações',
                                arquivo:
                                    'DSE_Materiais_2026/2. Professor Projeto de Vida/5. Atividade_Pre_Autoavaliacao/3. Anexo2_Situacoes.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Material Complementar',
                        arquivos: [
                            {
                                nome: 'Audiobook - Diálogos Socioemocionais',
                                arquivo: 'DSE_Materiais_2026/2.+Professor+Projeto+de+Vida/6.+Material+complementar/Audiobook_DSE.mp3',
                            },
                            {
                                nome: 'Infográficos das Macrocompetências',
                                arquivo:
                                    'DSE_Materiais_2026/2.+Professor+Projeto+de+Vida/6.+Material+complementar/Infogr%C3%A1ficos+das+Macrocompet%C3%AAncias.pdf',
                            },
                            {
                                nome: 'Priorização de Competências Socioemocionais',
                                arquivo:
                                    'DSE_Materiais_2026/2.+Professor+Projeto+de+Vida/6.+Material+complementar/Prioriza%C3%A7%C3%A3o+de+Compet%C3%AAncias+Socioemocionais.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Autoavaliações',
                        subPastas: [
                            {
                                titleSubPasta: 'Caderno - 1ª série',
                                arquivos: [
                                    {
                                        nome: 'A4 - Curiosidade para Aprender - 15',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 1ª série/A4 - CURIOSAIDADE PARA APRENDER - 15.pdf',
                                    },
                                    {
                                        nome: 'A4 - Imaginação Criativa - 11',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 1ª série/A4 - IMAGINAÇÃO CRIATIVA - 11.pdf',
                                    },
                                    {
                                        nome: 'A4 - Iniciativa Social - 6',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 1ª série/A4 - INICIATIVA SOCIAL - 6.pdf',
                                    },
                                    {
                                        nome: 'A4 - Persistência - 17',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 1ª série/A4 - PERSISTÊNCIA - 17.pdf',
                                    },
                                    {
                                        nome: 'A4 - Respeito - 4',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 1ª série/A4 - RESPEITO - 4.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância à Frustração - 10',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 1ª série/A4 - TOLERÂNCIA À FRUSTRAÇÃO - 10.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo: 'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 1ª série/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 1ª série/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 2ª série',
                                arquivos: [
                                    {
                                        nome: 'A4 - Assertividade - 18',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 2ª série/A4 - ASSERTIVIDADE - 18.pdf',
                                    },
                                    {
                                        nome: 'A4 - Autoconfiança - 6',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 2ª série/A4 - AUTOCONFIANÇA - 6.pdf',
                                    },
                                    {
                                        nome: 'A4 - Empatia - 13',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 2ª série/A4 - EMPATIA - 13.pdf',
                                    },
                                    {
                                        nome: 'A4 - Foco - 3',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 2ª série/A4 - FOCO - 3.pdf',
                                    },
                                    {
                                        nome: 'A4 - Interesse Artístico - 7',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 2ª série/A4 - INTERESSE ARTÍSTICO - 7.pdf',
                                    },
                                    {
                                        nome: 'A4 - Organização - 13',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 2ª série/A4 - ORGANIZAÇÃO - 13.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo: 'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 2ª série/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 2ª série/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 3ª série',
                                arquivos: [
                                    {
                                        nome: 'A4 - Confiança - 16',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 3ª série/A4 - CONFIANÇA - 16.pdf',
                                    },
                                    {
                                        nome: 'A4 - Curiosidade para Aprender - 16',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 3ª série/A4 - CURIOSAIDADE PARA APRENDER - 16.pdf',
                                    },
                                    {
                                        nome: 'A4 - Determinação - 19',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 3ª série/A4 - DETERMINAÇÃO - 19.pdf',
                                    },
                                    {
                                        nome: 'A4 - Entusiasmo - 9',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 3ª série/A4 - ENTUSIASMO - 9.pdf',
                                    },
                                    {
                                        nome: 'A4 - Responsabilidade - 8',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 3ª série/A4 - RESPONSABILIDADE - 8.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância ao Estresse - 15',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 3ª série/A4 - TOLERÂNCIA AO ESTRESSE - 15.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo: 'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 3ª série/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 3ª série/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 6º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Determinação - 18',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 6° ano/A4 - DETERMINAÇÃO - 18.pdf',
                                    },
                                    {
                                        nome: 'A4 - Empatia - 11',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 6° ano/A4 - EMPATIA - 11.pdf',
                                    },
                                    {
                                        nome: 'A4 - Imaginação Criativa - 10',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 6° ano/A4 - IMAGINAÇÃO CRIATIVA - 10.pdf',
                                    },
                                    {
                                        nome: 'A4 - Iniciativa Social - 4',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 6° ano/A4 - INICIATIVA SOCIAL - 4.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância à Frustração - 9',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 6° ano/A4 - TOLERÂNCIA À FRUSTRAÇÃO - 9.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo: 'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 6° ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 6° ano/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 7º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Assertividade - 17',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 7° ano/A4 - ASSERTIVIDADE - 17.pdf',
                                    },
                                    {
                                        nome: 'A4 - Curiosidade para Aprender - 14',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 7° ano/A4 - CURIOSAIDADE PARA APRENDER - 14.pdf',
                                    },
                                    {
                                        nome: 'A4 - Foco - 2',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 7° ano/A4 - FOCO - 2.pdf',
                                    },
                                    {
                                        nome: 'A4 - Respeito - 3',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 7° ano/A4 - RESPEITO - 3.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância ao Estresse - 13',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 7° ano/A4 - TOLERÂNCIA AO ESTRESSE - 13.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo: 'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 7° ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 7° ano/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 8º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Autoconfiança - 5',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 8°ano/A4 - AUTOCONFIANÇA - 5.pdf',
                                    },
                                    {
                                        nome: 'A4 - Empatia - 12',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 8°ano/A4 - EMPATIA - 12.pdf',
                                    },
                                    {
                                        nome: 'A4 - Interesse Artístico - 6',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 8°ano/A4 - INTERESSE ARTÍSTICO - 6.pdf',
                                    },
                                    {
                                        nome: 'A4 - Organização - 12',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 8°ano/A4 - ORGANIZAÇÃO - 12.pdf',
                                    },
                                    {
                                        nome: 'A4 - Responsabilidade - 7',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 8°ano/A4 - RESPONSABILIDADE - 7.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo: 'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 8°ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 8°ano/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 9º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Confiança - 15',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 9° ano/A4 - CONFIANÇA - 15.pdf',
                                    },
                                    {
                                        nome: 'A4 - Entusiasmo - 8',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 9° ano/A4 - ENTUSIASMO - 8.pdf',
                                    },
                                    {
                                        nome: 'A4 - Iniciativa Social - 5',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 9° ano/A4 - INICIATIVA SOCIAL - 5.pdf',
                                    },
                                    {
                                        nome: 'A4 - Persistência - 16',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 9° ano/A4 - PERSISTÊNCIA - 16.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância ao Estresse - 14',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 9° ano/A4 - TOLERÂNCIA AO ESTRESSE - 14.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo: 'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 9° ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/2. Professor Projeto de Vida/7. Autoavaliações/Caderno - 9° ano/Página final.pdf',
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        title: 'Coordenação e direção escolar',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'O que é o Diálogos Socioemocionais',
                        arquivo:
                            'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/1.+O+que+%C3%A9+o+Di%C3%A1logos+Socioemocionais.pdf',
                    },
                    {
                        nome: 'Caderno do professor',
                        arquivo: 'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/2.+Caderno+do+professor.pdf',
                    },
                    {
                        nome: 'Sistemática de Acompanhamento',
                        arquivo:
                            'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/3.+Sistem%C3%A1tica+de+Acompanhamento.pdf',
                    },
                    {
                        nome: 'Caderno do Coordenador Escolar',
                        arquivo: 'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/4.+Caderno+do+Coordenador+Escolar.pdf',
                    },
                    {
                        nome: 'Manual de aplicação da Autoavaliação',
                        arquivo:
                            'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/5.+Manual+de+aplica%C3%A7%C3%A3o+da+Autoavalia%C3%A7%C3%A3o.pdf',
                    },
                ],
                subPastas: [
                    {
                        titleSubPasta: 'Pautas para formação de professores',
                        subPastas: [
                            {
                                titleSubPasta: 'Atividades',
                                arquivos: [
                                    {
                                        nome: 'Anexo',
                                        arquivo:
                                            'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/6.+Pautas+para+forma%C3%A7%C3%A3o+de+professores/1.+Atividades/Anexo.pdf',
                                    },
                                    {
                                        nome: 'Pauta Formativa',
                                        arquivo:
                                            'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/6.+Pautas+para+forma%C3%A7%C3%A3o+de+professores/1.+Atividades/Pauta_Formativa.pdf',
                                    },
                                    {
                                        nome: 'PPT de apoio',
                                        arquivo:
                                            'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/6.+Pautas+para+forma%C3%A7%C3%A3o+de+professores/1.+Atividades/PPT+de+apoio.pptx',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Devolutiva e PDP',
                                arquivos: [
                                    {
                                        nome: 'Anexo 1',
                                        arquivo:
                                            'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/6.+Pautas+para+forma%C3%A7%C3%A3o+de+professores/2.+Devolutiva+e+PDP/Anexo1.pdf',
                                    },
                                    {
                                        nome: 'Anexo 2',
                                        arquivo:
                                            'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/6.+Pautas+para+forma%C3%A7%C3%A3o+de+professores/2.+Devolutiva+e+PDP/Anexo2.pdf',
                                    },
                                    {
                                        nome: 'Pauta Formativa',
                                        arquivo:
                                            'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/6.+Pautas+para+forma%C3%A7%C3%A3o+de+professores/2.+Devolutiva+e+PDP/Pauta+Formativa.pdf',
                                    },
                                    {
                                        nome: 'PPT de apoio',
                                        arquivo:
                                            'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/6.+Pautas+para+forma%C3%A7%C3%A3o+de+professores/2.+Devolutiva+e+PDP/PPT+de+apoio.pptx',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Autoavaliações',
                        subPastas: [
                            {
                                titleSubPasta: 'Caderno - 1ª série',
                                arquivos: [
                                    {
                                        nome: 'A4 - Curiosidade para Aprender - 15',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 1ª série/A4 - CURIOSAIDADE PARA APRENDER - 15.pdf',
                                    },
                                    {
                                        nome: 'A4 - Imaginação Criativa - 11',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 1ª série/A4 - IMAGINAÇÃO CRIATIVA - 11.pdf',
                                    },
                                    {
                                        nome: 'A4 - Iniciativa Social - 6',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 1ª série/A4 - INICIATIVA SOCIAL - 6.pdf',
                                    },
                                    {
                                        nome: 'A4 - Persistência - 17',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 1ª série/A4 - PERSISTÊNCIA - 17.pdf',
                                    },
                                    {
                                        nome: 'A4 - Respeito - 4',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 1ª série/A4 - RESPEITO - 4.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância à Frustração - 10',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 1ª série/A4 - TOLERÂNCIA À FRUSTRAÇÃO - 10.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 1ª série/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 1ª série/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 2ª série',
                                arquivos: [
                                    {
                                        nome: 'A4 - Assertividade - 18',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 2ª série/A4 - ASSERTIVIDADE - 18.pdf',
                                    },
                                    {
                                        nome: 'A4 - Autoconfiança - 6',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 2ª série/A4 - AUTOCONFIANÇA - 6.pdf',
                                    },
                                    {
                                        nome: 'A4 - Empatia - 13',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 2ª série/A4 - EMPATIA - 13.pdf',
                                    },
                                    {
                                        nome: 'A4 - Foco - 3',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 2ª série/A4 - FOCO - 3.pdf',
                                    },
                                    {
                                        nome: 'A4 - Interesse Artístico - 7',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 2ª série/A4 - INTERESSE ARTÍSTICO - 7.pdf',
                                    },
                                    {
                                        nome: 'A4 - Organização - 13',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 2ª série/A4 - ORGANIZAÇÃO - 13.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 2ª série/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 2ª série/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 3ª série',
                                arquivos: [
                                    {
                                        nome: 'A4 - Confiança - 16',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 3ª série/A4 - CONFIANÇA - 16.pdf',
                                    },
                                    {
                                        nome: 'A4 - Curiosidade para Aprender - 16',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 3ª série/A4 - CURIOSAIDADE PARA APRENDER - 16.pdf',
                                    },
                                    {
                                        nome: 'A4 - Determinação - 19',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 3ª série/A4 - DETERMINAÇÃO - 19.pdf',
                                    },
                                    {
                                        nome: 'A4 - Entusiasmo - 9',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 3ª série/A4 - ENTUSIASMO - 9.pdf',
                                    },
                                    {
                                        nome: 'A4 - Responsabilidade - 8',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 3ª série/A4 - RESPONSABILIDADE - 8.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância ao Estresse - 15',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 3ª série/A4 - TOLERÂNCIA AO ESTRESSE - 15.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 3ª série/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 3ª série/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 6º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Determinação - 18',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 6° ano/A4 - DETERMINAÇÃO - 18.pdf',
                                    },
                                    {
                                        nome: 'A4 - Empatia - 11',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 6° ano/A4 - EMPATIA - 11.pdf',
                                    },
                                    {
                                        nome: 'A4 - Imaginação Criativa - 10',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 6° ano/A4 - IMAGINAÇÃO CRIATIVA - 10.pdf',
                                    },
                                    {
                                        nome: 'A4 - Iniciativa Social - 4',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 6° ano/A4 - INICIATIVA SOCIAL - 4.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância à Frustração - 9',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 6° ano/A4 - TOLERÂNCIA À FRUSTRAÇÃO - 9.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 6° ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 6° ano/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 7º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Assertividade - 17',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 7° ano/A4 - ASSERTIVIDADE - 17.pdf',
                                    },
                                    {
                                        nome: 'A4 - Curiosidade para Aprender - 14',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 7° ano/A4 - CURIOSAIDADE PARA APRENDER - 14.pdf',
                                    },
                                    {
                                        nome: 'A4 - Foco - 2',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 7° ano/A4 - FOCO - 2.pdf',
                                    },
                                    {
                                        nome: 'A4 - Respeito - 3',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 7° ano/A4 - RESPEITO - 3.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância ao Estresse - 13',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 7° ano/A4 - TOLERÂNCIA AO ESTRESSE - 13.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 7° ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 7° ano/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 8º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Autoconfiança - 5',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 8°ano/A4 - AUTOCONFIANÇA - 5.pdf',
                                    },
                                    {
                                        nome: 'A4 - Empatia - 12',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 8°ano/A4 - EMPATIA - 12.pdf',
                                    },
                                    {
                                        nome: 'A4 - Interesse Artístico - 6',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 8°ano/A4 - INTERESSE ARTÍSTICO - 6.pdf',
                                    },
                                    {
                                        nome: 'A4 - Organização - 12',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 8°ano/A4 - ORGANIZAÇÃO - 12.pdf',
                                    },
                                    {
                                        nome: 'A4 - Responsabilidade - 7',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 8°ano/A4 - RESPONSABILIDADE - 7.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 8°ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 8°ano/Página final.pdf',
                                    },
                                ],
                            },
                            {
                                titleSubPasta: 'Caderno - 9º ano',
                                arquivos: [
                                    {
                                        nome: 'A4 - Confiança - 15',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 9° ano/A4 - CONFIANÇA - 15.pdf',
                                    },
                                    {
                                        nome: 'A4 - Entusiasmo - 8',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 9° ano/A4 - ENTUSIASMO - 8.pdf',
                                    },
                                    {
                                        nome: 'A4 - Iniciativa Social - 5',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 9° ano/A4 - INICIATIVA SOCIAL - 5.pdf',
                                    },
                                    {
                                        nome: 'A4 - Persistência - 16',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 9° ano/A4 - PERSISTÊNCIA - 16.pdf',
                                    },
                                    {
                                        nome: 'A4 - Tolerância ao Estresse - 14',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 9° ano/A4 - TOLERÂNCIA AO ESTRESSE - 14.pdf',
                                    },
                                    {
                                        nome: 'Capa',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 9° ano/Capa.pdf',
                                    },
                                    {
                                        nome: 'Página final',
                                        arquivo:
                                            'DSE_Materiais_2026/3. Coordenação e direção escolar/7. Autoavaliações/Caderno - 9° ano/Página final.pdf',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Material Complementar',
                        arquivos: [
                            {
                                nome: 'Audiobook - Diálogos Socioemocionais',
                                arquivo:
                                    'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/8.+Material+complementar/Audiobook_DSE.mp3',
                            },
                            {
                                nome: 'Infográficos das Macrocompetências',
                                arquivo:
                                    'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/8.+Material+complementar/Infogr%C3%A1ficos+das+Macrocompet%C3%AAncias.pdf',
                            },
                            {
                                nome: 'Priorização de Competências Socioemocionais',
                                arquivo:
                                    'DSE_Materiais_2026/3.+Coordena%C3%A7%C3%A3o+e+dire%C3%A7%C3%A3o+escolar/8.+Material+complementar/Prioriza%C3%A7%C3%A3o+de+Compet%C3%AAncias+Socioemocionais.pdf',
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        title: 'Técnicos da Secretaria',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'O que é o Diálogos Socioemocionais',
                        arquivo: 'DSE_Materiais_2026/4.+T%C3%A9cnicos+da+Secretaria/1.+O+que+%C3%A9+o+Di%C3%A1logos+Socioemocionais.pdf',
                    },
                    {
                        nome: 'Caderno Coordenador do DSE na Rede',
                        arquivo: 'DSE_Materiais_2026/4.+T%C3%A9cnicos+da+Secretaria/2.+Caderno+Coordenador+do+DSE+na+Rede.pdf',
                    },
                    {
                        nome: 'Sistemática de Acompanhamento',
                        arquivo: 'DSE_Materiais_2026/4.+T%C3%A9cnicos+da+Secretaria/3.+Sistem%C3%A1tica+de+Acompanhamento.pdf',
                    },
                    {
                        nome: 'Caderno do Coordenador Escolar',
                        arquivo: 'DSE_Materiais_2026/4.+T%C3%A9cnicos+da+Secretaria/4.+Caderno+do+Coordenador+Escolar.pdf',
                    },
                    {
                        nome: 'Caderno do Professor',
                        arquivo: 'DSE_Materiais_2026/4.+T%C3%A9cnicos+da+Secretaria/5.+Caderno+do+professor.pdf',
                    },
                ],
                subPastas: [
                    {
                        titleSubPasta: 'Material Complementar',
                        arquivos: [
                            {
                                nome: 'Audiobook - Diálogos Socioemocionais',
                                arquivo: 'DSE_Materiais_2026/4. Técnicos da Secretaria/6. Material complementar/Audiobook_DSE.mp3',
                            },
                            {
                                nome: 'Infográficos das Macrocompetências',
                                arquivo:
                                    'DSE_Materiais_2026/4. Técnicos da Secretaria/6. Material complementar/Infográficos das Macrocompetências.pdf',
                            },
                            {
                                nome: 'Priorização de Competências Socioemocionais',
                                arquivo:
                                    'DSE_Materiais_2026/4. Técnicos da Secretaria/6. Material complementar/Priorização de Competências Socioemocionais.pdf',
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
